import 'slick-carousel';
import '~/js/sections/general/destinations/includes/turks-top-slider';
import QuickQuote from '~/js/components/global/QuickQuote';
import navigationBarHandler from '~/js/modules/destinations/navigation-bar-handler';
import animateElements from '~/js/modules/animate-elements.js';

// Navigation bar handler
const navBarWrapper = document.querySelector('.resort-nav-wrapper');

navigationBarHandler(navBarWrapper);

// Quick Quote
const datePickerElements = document.querySelector('#home-qq');

ReactDOM.render(
  <QuickQuote
    schedulerModeIndex={4}
    hasCountries={ false }
    noLabels
    defaultCountry="JM"
    quoteButtonText="Rates &amp; Availability"
    occupancyLabels={ false }
    adultsDropdownPlaceHolder="<span class='occupancy-placeholder'>Adults<span class='display-block'>(Age 16+)</span></span>"
    childrenDropdownPlaceHolder="<span class='occupancy-placeholder'>Kids<span class='display-block'>(Age 0-15)</span></span>"
  />,
  datePickerElements
);
// -- End QQ --

const expirienceButton = $('.js-expirience-read-more');
const expirienceAdded = $('.js-expirience-added');
let isExpirienceShow = false;

const $carousel = $('#inc-carousel');
const $control = $('#inc-carousel-control');

$('.js-scroll-below').on('click', () => {
  const $main = $('html, body');
  const $heroSection = $('#hero-slider');
  const heroSectionTop = $heroSection.offset().top;
  const heroSectionHeight = $heroSection.outerHeight();
  const headerCollapsedHeight = 34;
  let stickyNavHeight = 0;

  if ($heroSection.hasClass('sticky-nav--enabled')) {
    stickyNavHeight = 80;
  }

  const scrollHere = heroSectionTop + heroSectionHeight - headerCollapsedHeight - stickyNavHeight;

  $main.animate({
    scrollTop: scrollHere
  }, 1000);
});

expirienceButton.on('click', () => {
  isExpirienceShow = !isExpirienceShow;
  if (isExpirienceShow) {
    expirienceAdded.removeClass('hide');
    expirienceButton.children('span').text('read less');
  } else {
    expirienceAdded.addClass('hide');
    expirienceButton.children('span').text('read more');
  }
});

const $counter = $('.carousel-counter');

$carousel.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
  // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  const i = (currentSlide ? currentSlide : 0) + 1;

  $counter.text(i + '/' + slick.slideCount);
});

$carousel.slick({
  appendArrows: $control,
  mobileFirst: true,
  variableWidth: true,
  centerMode: true,
  arrows: true,
  prevArrow: '<button class="icon-button-prev arrow-prev"></button>',
  nextArrow: '<button class="icon-button-next arrow-next"></button>',
});

// Sliders
const slider = $('.js-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  prevArrow: '<span class="prev resort-slider-arrow"><i class="icon icon-button-arrow-prev"></i></span>',
  nextArrow: '<span class="next resort-slider-arrow"><i class="icon icon-button-arrow-next"></i></span>'
});

slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  const nextImg = slick.$slides[nextSlide];
  const srcImg = nextImg.dataset.src;

  nextImg.src = srcImg;
  nextImg.addEventListener('load', () => {
    nextImg.style.opacity = 1;
  });
});

// Weddings collage
animateElements();

const stickyNav = () => {
  const nav = document.querySelector('.resort-nav');
  const topSection = document.querySelector('#hero-slider');
  const header = document.querySelector('header');
  const topHeight = topSection.offsetTop + topSection.clientHeight - header.clientHeight;
  const headerHeight = header.clientHeight;

  if (window.pageYOffset > topHeight) {
    nav.classList.add('sticky-nav');
    document.querySelector('.resort-nav-wrapper').style.height = `${nav.clientHeight}px`;
    nav.style.top = `${headerHeight}px`;
  }
  if (window.pageYOffset < topHeight) {
    nav.classList.remove('sticky-nav');
    document.querySelector('.resort-nav-wrapper').style.height = 'auto';
  }
};

// scroll listener
window.addEventListener('scroll', () => stickyNav());
window.addEventListener('resize', () => stickyNav());
